var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.60722 0 0 5.60722 0 12.5C0 19.3928 5.60722 25 12.5 25C19.3928 25 25 19.3928 25 12.5C25 5.60722 19.3928 0 12.5 0Z",
    fill: "#71DE56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8351 9.85068L12.0642 16.6214C11.861 16.8245 11.5944 16.9268 11.3277 16.9268C11.0611 16.9268 10.7944 16.8245 10.5913 16.6214L7.20595 13.236C6.79854 12.8288 6.79854 12.1704 7.20595 11.7632C7.61317 11.3558 8.27139 11.3558 8.6788 11.7632L11.3277 14.4121L17.3622 8.37782C17.7694 7.97041 18.4276 7.97041 18.8351 8.37782C19.2423 8.78504 19.2423 9.44327 18.8351 9.85068Z",
    fill: "#F0EEF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFeature);
export default __webpack_public_path__ + "static/media/activeFeature.98dd1a6e3c55acea89d9ec54a9e6a718.svg";
export { ForwardRef as ReactComponent };